// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "scrollBody-1KjEp";
var _4 = "modal-1-H6U";
var _5 = "modal_rounded-2oy-l";
var _6 = "closeIcon-te75K";
var _7 = "closeIcon_mobileFullScreen-2MP7v";
export { _1 as "__esModule", _2 as "mobile", _3 as "scrollBody", _4 as "modal", _5 as "modal_rounded", _6 as "closeIcon", _7 as "closeIcon_mobileFullScreen" }
export default { "__esModule": _1, "mobile": _2, "scrollBody": _3, "modal": _4, "modal_rounded": _5, "closeIcon": _6, "closeIcon_mobileFullScreen": _7 }
